import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { UserManager, UserManagerSettings, User } from 'oidc-client';
import { Observable } from "rxjs/Observable";
import { environment } from "environments/environment";

@Injectable()
export class AuthService implements CanActivate {

  private manager = new UserManager(environment.authSettings);
  private user:User;
  constructor() {
    // Load in the current OpenID Connect authenticated user.
    this.manager.getUser().then(user => {
      this.user = user;
    })
  }

  IsLoggedIn(): boolean {
    return this.user && !this.user.expired;
  }

  getClaims(): any {
    return this.user.profile;
  }

  getAuthorizationHeaderValue(): string {
    return `${this.user.token_type} ${this.user.access_token}`;
  }

  startAuthentication(): Promise<void> {
    return this.manager.signinRedirect();
  }

  completeAuthentication(): Promise<void> {
      return this.manager.signinRedirectCallback().then(user => {
          this.user = user;
      });
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.IsLoggedIn())
      return true;
    this.startAuthentication();
    return false;
  }
}



// WEBPACK FOOTER //
// C:/git/flowdesigner/src/services/auth.service.ts